import { FC } from "react";
import { IconProps } from "./types";

export const ArrowDownCircleLine: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M6 13.155a.58.58 0 0 0 .17.41l5.415 5.391a.605.605 0 0 0 .64.126.582.582 0 0 0 .19-.126l5.415-5.388a.595.595 0 0 0 .127-.638.575.575 0 0 0-.316-.316.586.586 0 0 0-.636.126l-4.419 4.398V5.458a.581.581 0 0 0-.585-.583.587.587 0 0 0-.586.583v11.684l-4.419-4.398a.585.585 0 0 0-.996.411z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.721 4.39a12 12 0 1 0 18.557 15.22A12 12 0 0 0 2.721 4.39zM21.05 5.957a10.884 10.884 0 0 1 1.834 6.047 10.899 10.899 0 0 1-10.883 10.884A10.884 10.884 0 1 1 21.05 5.957z"
      fill={fill}
    />
  </svg>
);
